import * as style from './style.css';
import { ILayoutStat } from '../../../../types/layouts/layoutStat';
import React, { useMemo } from 'react';
import { UIText1, UIText2 } from '@cian/ui-kit';
import { trackClickLayoutsSeoLink } from '../../../../utils/tracking/trackSeoLayoutPageLinkClick';

interface ILayoutsLinksProps {
  layoutStats: ILayoutStat[];
  newbuildingId: number;
}

const LAYOUTS_LIMIT = 3;

export const LayoutsLinks = ({ layoutStats, newbuildingId }: ILayoutsLinksProps): React.JSX.Element => {
  const layoutsToShow = useMemo(() => layoutStats.slice(0, LAYOUTS_LIMIT), [layoutStats]);

  const onRoomLinkClick = React.useCallback(
    () => trackClickLayoutsSeoLink({ newbuildingId, withRoomFilter: true }),
    [],
  );

  return (
    <div className={style['container']}>
      {layoutsToShow.map((layoutStat, index) => (
        <div key={index}>
          <UIText2>{layoutStat.roomCountText}</UIText2>
          <UIText1>{layoutStat.priceRange}</UIText1>
          <UIText2 color="control-main-primary-hovered">
            <a
              className={style['link']}
              href={layoutStat.layoutsUrl}
              onClick={onRoomLinkClick}
              target="_blank"
              rel="noreferrer"
            >
              {layoutStat.layoutCount}
            </a>
          </UIText2>
        </div>
      ))}
    </div>
  );
};
